import React from 'react'

import Button, { ButtonSize, ButtonVariant } from '../ui/button'
import { ReactComponent as MailIcon } from '../../static/images/feedback-mail.svg'
import FeedbackModal from './FeedbackModal'
import './styles.scss'

export type FeedbackButtonProps = {
  children: React.ReactNode
  variant?: ButtonVariant
  size?: ButtonSize
  className?: string
  iconPosition?: 'start' | 'end'
  onSubmitted?: () => void
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({
  children,
  variant = ButtonVariant.PRIMARY,
  size,
  className,
  iconPosition = 'start',
  onSubmitted,
}) => {
  const [modalOpen, setModalOpen] = React.useState(false)

  return (
    <>
      <Button
        size={size}
        variant={variant}
        icon={<MailIcon width={18} height={18} />}
        iconPosition={iconPosition}
        className={className}
        onClick={() => setModalOpen(true)}
      >
        {children}
      </Button>
      <FeedbackModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmitted={() => onSubmitted?.()}
      />
    </>
  )
}

export default FeedbackButton
